import request from './request.js';
import {requestbody} from './request.js'

//导入
export async function subLegerUpload (params = {}) {
    return await request('subLeger/importExcel', 'post', params)
}

//上传结果展示分页查询
export async function subLegerResultQuery (params = {}) {
    return await requestbody('subLeger/list/page', 'post', params)
}

//凭证明细列表分页
export async function subLegerVoucherDetailQuery (params = {}) {
    return await requestbody('subLeger/details/page', 'post', params)
}

//进项凭证明细列表分页
export async function iinvSubLegerVoucherDetailQuery (params = {}) {
    return await requestbody('subLeger/iinv/details/page', 'post', params)
}

//删除
export async function subLegerVoucherDetailDelete (params = {}) {
    return await requestbody('subLeger/details/deleteBatch', 'post', params)
}

//删除
export async function iinvSubLegerVoucherDetailDelete (params = {}) {
    return await requestbody('subLeger/iinv/details/deleteBatch', 'post', params)
}

// 导入提示操作后处理
export async function subLegerUploadStep (params = {}) {
    return await requestbody('subLeger/processImportExcel', 'post', params)
}

// 业务类型查询
export async function getCompanyObstWithVoucher (params = {}) {
    return await requestbody('business/getCompanyObstWithVoucher', 'post', params)
}

// 查询当前用户下所有的公司信息
export async function queryCompanyList(params = {}) {
    return await request('/sys/queryCompanyList', 'post', params)
}